module.exports = __webpack_public_path__ + "media/images/checkin-bg-ddaec522.svg";